module.exports = __webpack_public_path__ + "images/landing/video-previews/blog-video_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/blog-video_2x.jpg
// module id = 1QkR
// module chunks = 1